import React from 'react'
import PropTypes from 'prop-types'
import PDFViewer from "../../PDFViewer";
import { DEFAULT_PDF_ZOOM } from '../../constants';

class FileViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileType: null,
        }
    }

    componentDidMount() {
        const { data } = this.props;
        if (!data || data.length === 0) return;

        const uint8 = data instanceof Uint8Array ? data : new Uint8Array(data);

        // Detect file type
        const firstTwoBytes = uint8.subarray(0, 2);
        let fileType = null;
        if (firstTwoBytes[0] === 0xff && firstTwoBytes[1] === 0xd8) {
            fileType = 'image/jpeg';
        } else if (firstTwoBytes[0] === 0x89 && firstTwoBytes[1] === 0x50) {
            fileType = 'image/png';
        } else if (firstTwoBytes[0] === 0x25 && firstTwoBytes[1] === 0x50) {
            fileType = 'application/pdf';
        }

        this.setState({ fileType });
    }

    toBase64(uint8Array) {
        let binary = '';
        const chunkSize = 0x8000; // 32KB chunks
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
            const chunk = uint8Array.subarray(i, i + chunkSize);
            binary += String.fromCharCode(...chunk);
        }
        return btoa(binary);
    }

    render() {
        const { fileType } = this.state;
        const { data, scale } = this.props;

        if (!data || data.length === 0) return <p>No file to display</p>;

        const uint8 = data instanceof Uint8Array ? data : new Uint8Array(data);

        switch (fileType) {
            case 'application/pdf':
                return <PDFViewer data={uint8} scale={scale} />;

            case 'image/jpeg':
            case 'image/png':
                const dataUrl = `data:${fileType};base64,${this.toBase64(uint8)}`
                const imageScale = this.props.scale && this.props.scale !== DEFAULT_PDF_ZOOM ? this.props.scale : 1.0
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '10%',
                        }}
                    >
                        <div
                            style={{
                                width: '210mm',      // A4 width
                                height: '297mm',     // A4 height
                                border: '1px solid grey',
                                overflow: 'hidden',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#fff',
                            }}
                        >
                            <img
                                src={dataUrl}
                                alt="image"
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    transform: `scale(${imageScale})`,
                                    transformOrigin: 'top left',
                                }}
                            />
                        </div>
                    </div>
                );

            default:
                return <p>Cannot view this File. Unsupported File Type.</p>;
        }
    }
}

FileViewer.propTypes = {
    data: PropTypes.oneOfType([PropTypes.instanceOf(Uint8Array), PropTypes.array]),
    scale: PropTypes.number,
}

FileViewer.defaultProps = {
    data: new Uint8Array(),
    scale: 1.0,
}

export default FileViewer;